module.exports = __webpack_public_path__ + "static/media/templates-category.df986d96.svg";